import { Component, OnInit, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, FormsModule, Validators, DefaultValueAccessor } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { INoteInput } from '../../../shared/models/NotesInputModel';
import { OfferService } from '../../../shared/providers/offer.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { ValidationService, spaceOnlyValidator, EmailValidator, DateValidator, dropdownItemSelected } from '../../../shared/providers/validation.service';
import { CommonService } from '../../../shared/providers/common.service';
import { UserManagerService } from '../../../shared/providers/user-manager.service';
import { OrderPipe } from 'ngx-order-pipe';
import { ILookUp } from '../../../shared/models/LookUpOutputModel';
import { ILeadCheckListEditModel } from '../../../shared/models/LeadCheckListEditModel';
import { NgSelectModule, NgOption } from '@ng-select/ng-select';
import { ResultOutputModel } from '../../../shared/models/resultOutputModel';
import { LoaderService } from '../../../shared/providers/loader.service';
import { SharedService } from '../../../shared/providers/shared.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { IOfferDetailOutputModel } from '../../../shared/models/OfferDetailOutputModel';

enum Status {
  New = 1,
  Complete = 2,
  InProgress = 3
}

enum TaskType {
  AdminCreatedTask = 1,
  UserCreatedTask = 2
}

interface IPhaseInputModel {
  Id: number;
  PhaseName: string;
  StartDate: Date;
  EndDate: Date
  IsPhaseCompleted: boolean;
  CompletedDate?: Date;
  IsEditAllDates: boolean;
  loggedinuserid: number;
}

@Component({
  selector: 'app-offer-task-list',
  templateUrl: './offer-task-list.component.html',
  styleUrls: ['./offer-task-list.component.css']
})
export class OfferTaskListComponent implements OnInit {

  constructor(private modalService: BsModalService, private _OfferService: OfferService, private _validation: ValidationService,
    private orderPipe: OrderPipe, private _commonService: CommonService, private Toast: ToastService,
    private _userManagerService: UserManagerService, private Shared: SharedService, private Authentication: AuthenticationService, private Loader: LoaderService) {

  }
  @Input() inputOfferGuid: string = "";
  offerDetails = {} as IOfferDetailOutputModel;
  @Input() Input: boolean = false;
  @Output() showBadge = new EventEmitter();
  offerGuid = "";
  associatedTask = [];
  eventCheckbox: boolean = false;
  lookupList: ILookUp[];
  associatedStatusList = [];
  userRoleList = [];
  LeadCheckListEditModel = {} as ILeadCheckListEditModel;
  AddTaskModel = {} as ILeadCheckListEditModel;
  PhaseInputModel = {} as IPhaseInputModel;
  taskType = TaskType;
  assigneeList = [];
  assignedPhaseDetails = [];
  EditTaskForm: FormGroup;
  AddTaskForm: FormGroup;
  EditPhaseForm: FormGroup;
  isbindAllTaskCalled = false;
  isEditTaskFormSubmitted = false;
  isAddTaskFormSubmitted = false;
  blockChartRebind = false;
  openedPhases: number[] = [];
  user: any;
  ngOnInit() {
    this.user = this.Authentication.user;
    this.EditTaskForm = new FormGroup({
      'txtTaskname': new FormControl(this.LeadCheckListEditModel.TaskName, [
        Validators.required,
        spaceOnlyValidator
      ]),
      'txtStartDate': new FormControl(this.LeadCheckListEditModel.StartDate, [
        DateValidator
      ]),
      'txtEndDate': new FormControl(this.LeadCheckListEditModel.EndDate, [
        DateValidator
      ]),
      'AssociatedStatus': new FormControl(this.LeadCheckListEditModel.AssociatedStatusId, [
      ]),
      'UserRole': new FormControl(this.LeadCheckListEditModel.ResponsibleUserId, [
      ]),
      'Assignee': new FormControl(this.LeadCheckListEditModel.AssigneeId, [
      ]),
      'Status': new FormControl(this.LeadCheckListEditModel.Status, [
      ]),
      'txtCompletedDate': new FormControl(this.LeadCheckListEditModel.CompletedDate, [
        DateValidator
      ]),
    })

    this.AddTaskForm = new FormGroup({
      'Add_txtTaskname': new FormControl(this.AddTaskModel.TaskName, [
        Validators.required,
        Validators.minLength(2),
        spaceOnlyValidator
      ]),
      'Add_txtStartDate': new FormControl(this.AddTaskModel.StartDate, [
        DateValidator
      ]),
      'Add_txtEndDate': new FormControl(this.AddTaskModel.EndDate, [
        DateValidator
      ]),
      'Add_AssociatedStatus': new FormControl(this.AddTaskModel.AssociatedStatusId, [
      ]),
      'Add_UserRole': new FormControl(this.AddTaskModel.ResponsibleUserId, [
      ]),
      'Add_Assignee': new FormControl(this.AddTaskModel.AssigneeId, [
      ]),
    })

    this.EditPhaseForm = new FormGroup({
      'Phase_txtPhasename': new FormControl(this.PhaseInputModel.PhaseName, [
      ]),
      'Phase_txtStartDate': new FormControl(this.PhaseInputModel.StartDate, [
        Validators.required,
        DateValidator
      ]),
      'Phase_txtEndDate': new FormControl(this.PhaseInputModel.EndDate, [
        Validators.required,
        DateValidator
      ]),
      'Phase_IsCompleted': new FormControl(this.PhaseInputModel.IsPhaseCompleted, [
      ]),
      'Phase_Completed': new FormControl(this.PhaseInputModel.CompletedDate, [
      ]),
    })


    this.AddTaskModel.AssociatedStatusId = 0;
    this.AddTaskModel.ResponsibleRoleId = 0;
    this.AddTaskModel.AssigneeId = 0;
    this.AddTaskModel.TaskName = null;

    this.offerGuid = this.inputOfferGuid;

    this._commonService.getLookupsByTypeId(26).subscribe(response => {
      this.lookupList = response.map(o => { return { id: o.Id, description: o.Description }; });
    });

    this._OfferService.GetTaskAssignee(this.offerGuid).subscribe(response => {
      this.TaskAssignee = response;
    });

    this.bindTaskPhaseDetails();
    this.blockChartRebind = false;
    this.Shared.offerPageReloadStatus.subscribe(res => {
      if (res && this.blockChartRebind && !this.isbindAllTaskCalled) {
        this.bindTaskPhaseDetails();
      }
      this.blockChartRebind = true;
      this.isbindAllTaskCalled = false;
    });
    this._commonService.getLookupsByTypeId(27).subscribe(response => {
      this.associatedStatusList = response.map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });
    });
    this._commonService.getUserRolesList().subscribe(response => {

      let UserList = [];
      if (this.Authentication.IsUserRole(this.Authentication.UserRole.Broker)) {
        UserList = response.filter(x => {
          return x.Description == this.Authentication.getUserRoleDescription(this.Authentication.UserRole.Admin) || x.Description == this.Authentication.getUserRoleDescription(this.Authentication.UserRole.SuperAdmin) || x.Description == this.Authentication.getUserRoleDescription(this.Authentication.UserRole.Broker) || x.Description == '1031' || x.Id == this.Authentication.UserRole.Seller
        });
      }
      else if (this.Authentication.IsUserRole(this.Authentication.UserRole.Principal) || this.Authentication.IsUserRole(this.Authentication.UserRole.Principal1031) || this.Authentication.IsUserRole(this.Authentication.UserRole.Seller)) {
        UserList = response.filter(x => {
          return x.Description == this.Authentication.getUserRoleDescription(this.Authentication.UserRole.Broker) || x.Description == '1031' || x.Id == this.Authentication.UserRole.Seller
        });
      }
      else if (this.Authentication.IsUserRole(this.Authentication.UserRole.ExternalBroker)) {
        UserList = response.filter(x => {
          return x.Description == this.Authentication.getUserRoleDescription(this.Authentication.UserRole.Broker) || x.Description == this.Authentication.getUserRoleDescription(this.Authentication.UserRole.ExternalBroker)
        });
      }
      else {
        UserList = response;
      }
      this.userRoleList = UserList.filter(x => x.Id != 5 && x.Id != 7 && x.Id != 8 && x.Id != 12).map(o => { return { id: o.Id, name: o.Description }; });

      //let p1031 = this.userRoleList.find(x => x.id == 4);
      //p1031.name = "Principal+1031";
      //this.userRoleList = this.userRoleList.sort((n1, n2) => {
      //    if (n1 > n2) {
      //        return 1;
      //    }

      //    if (n1 < n2) {
      //        return -1;
      //    }

      //    return 0;

      //});
    });
    this.setEditSettings();
  }


  get txtTaskname() { return this.EditTaskForm.get('txtTaskname'); }
  get txtStartDate() { return this.EditTaskForm.get('txtStartDate'); }
  get txtEndDate() { return this.EditTaskForm.get('txtEndDate'); }
  get AssociatedStatus() { return this.EditTaskForm.get('AssociatedStatus'); }
  get UserRole() { return this.EditTaskForm.get('UserRole'); }
  get Assignee() { return this.EditTaskForm.get('Assignee'); }
  get Status() { return this.EditTaskForm.get('Status'); }

  get Add_txtTaskname() { return this.AddTaskForm.get('Add_txtTaskname'); }
  get Add_txtStartDate() { return this.AddTaskForm.get('Add_txtStartDate'); }
  get Add_txtEndDate() { return this.AddTaskForm.get('Add_txtEndDate'); }
  get Add_AssociatedStatus() { return this.AddTaskForm.get('Add_AssociatedStatus'); }
  get Add_UserRole() { return this.AddTaskForm.get('Add_UserRole'); }
  get Add_Assignee() { return this.AddTaskForm.get('Add_Assignee'); }

  get Phase_txtPhasename() { return this.EditPhaseForm.get('Phase_txtPhasename'); }
  get Phase_txtStartDate() { return this.EditPhaseForm.get('Phase_txtStartDate'); }
  get Phase_txtEndDate() { return this.EditPhaseForm.get('Phase_txtEndDate'); }

  onPhaseCompleted() {
    if (!this.PhaseInputModel.IsPhaseCompleted) {
      this.PhaseInputModel.CompletedDate = null;
    }
  }

  bindTaskPhaseDetails() {
    this._OfferService.GetTaskPhaseDetails(this.offerGuid, this.user.Id).subscribe(response => {
      this.assignedPhaseDetails = response;
      this.assignedPhaseDetails.forEach(item => {
        item.StartDate = item.StartDate ? this._validation.convertUTCDateToLocalDate(item.StartDate) : null;
        item.EndDate = item.EndDate ? this._validation.convertUTCDateToLocalDate(item.EndDate) : null;
        item.CompletedDate = item.CompletedDate ? this._validation.convertUTCDateToLocalDate(item.CompletedDate) : null;
      });

      this.bindData();
    });
  }
  TaskAssigned(assignedStatus: boolean) {
    if (assignedStatus) {
      this.taskAdded = true;
      this.bindTaskPhaseDetails();
      this.setEditSettings();
      this.Shared.reloadOfferDetail(true);
      this.showBadge.emit(false);
    }
  }
  GoBack(Status: boolean) {
    if (Status) {
      this.showAssignTask = false;
      this.showBadge.emit(true);
    }
  }
  changeOfferStatus(leadId) {
    this.Loader.display(true);
    this._OfferService.ChangeLeadChecklistTaskStatus(leadId, 2252, this.user.Id).subscribe(response => {
      if (response) {
        this.Toast.addToast({ title: 'Success', msg: 'Task status changed to completed', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        this.Shared.reloadOfferDetail(true);
        let selectedTask = this.taskList.find(x => x.LeadCheckListId == leadId);
        if (selectedTask) {
          selectedTask.Status = 2252;
          selectedTask.StatusName = 'Completed';
        }
        else {
          this.bindTaskPhaseDetails();
        }
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: "Task Status Updatation Failed", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.Loader.display(false);
    });
  }
  onTaskStatusChange() {
    if (this.LeadCheckListEditModel.Status !== 2252) {
      this.LeadCheckListEditModel.CompletedDate = null;
    }
  }
  changePhaseStatus(phaseId, event) {
    this.Loader.display(true);
    this._OfferService.ChangeLeadPhaseStatus(phaseId, true, this.user.Id).subscribe(response => {
      if (response) {
        this.Toast.addToast({ title: 'Success', msg: 'Phase status changed to completed', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        // this.Shared.reloadOfferDetail(true);
        //this.bindData();
        let selectedPhase = this.associatedTask.find(x => x.TableId == phaseId);
        if (selectedPhase) {
          this.bindTaskPhaseDetails();
          selectedPhase.IsPhaseCompleted = true;
        }
        else {
          this.bindTaskPhaseDetails();
        }
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: "Phase Status Updatation Failed", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.Loader.display(false);
    });
  }
  AllowEdit = false;
  loggedInUserIsPropertyBroker = false;

  setEditSettings() {
    this._OfferService.GetPropertyContacts(this.offerGuid, this.user.Id).subscribe(res => {
      if (res == true) {
        this.AllowEdit = true;
        this._OfferService.getOfferDetails(this.offerGuid).subscribe(response => {
          this.offerDetails = response;
        });
      }
      else {

        this._OfferService.getOfferDetails(this.offerGuid).subscribe(response => {
          this.offerDetails = response;
          if (this.offerDetails.AssignedBrokerId === this.user.Id || this.IsloggedInUserIsAnAssociatedAgent(this.offerDetails.AssignedAgenstId, this.user.Id)) {
            this.AllowEdit = true;
            this.loggedInUserIsPropertyBroker = true;
          }
          else if ((this.Authentication.IsUserRole(this.Authentication.UserRole.Principal) || this.Authentication.IsUserRole(this.Authentication.UserRole.Principal1031) || this.Authentication.IsUserRole(this.Authentication.UserRole.ExternalBroker) || this.Authentication.IsUserRole(this.Authentication.UserRole.Seller)) && this.offerDetails.PrincipalId === this.user.Id) {
            this.AllowEdit = true;
          }
          else {
            this.AllowEdit = false;
          }

          if (this.Authentication.Admin() || this.Authentication.SuperAdmin()) {
            this.AllowEdit = true;
          }

          if (!this.loggedInUserIsPropertyBroker) {
            this._OfferService.getPropertyDetails(this.offerDetails.PropertyGuid).subscribe(response => {
              if (response.PrimaryContactId === this.user.Id) {
                this.loggedInUserIsPropertyBroker = true;
                this.AllowEdit = true;
                if (this.loggedInUserIsPropertyBroker && !this.taskAdded && this.associatedTask.length == 0) {
                  this.showBadge.emit(true);
                }
              }
            });
          }
          if ((this.offerDetails.AssignedBrokerId === this.user.Id || this.IsloggedInUserIsAnAssociatedAgent(this.offerDetails.AssignedAgenstId, this.user.Id) && this.associatedTask.length == 0)) {
            this.loggedInUserIsPropertyBroker = true;
            this.AllowEdit = true;
            if (this.loggedInUserIsPropertyBroker && !this.taskAdded) {
              this.showBadge.emit(true);
            }
          }
          if (this.loggedInUserIsPropertyBroker) {
            this.AllowEdit = true;
          }

        });
      }
    });
  }

  IsloggedInUserIsAnAssociatedAgent(AssociatedAgentList: number[], userId: number) {
    if (AssociatedAgentList && AssociatedAgentList.indexOf(userId) > -1) {
      return true;
    }
    return false;
  }


  TaskAssignee = [];
  isCompletedDateInvalid = false;
  CompletedDateInvalidMessage = "";
  isPhaseDateConfirmed = false;
  UpdateTask(template: TemplateRef<any>, classes, type: number = 0) {
    let currentEndDate = new Date();
    let currentStartDate = new Date();
    this.isEditTaskFormSubmitted = true;
    if (type == 1) {
      this.isPhaseDateConfirmed = true;
    }
    if (!this.EditTaskForm.invalid) {
      if ((!this._validation.isInvalidDropDown(this.LeadCheckListEditModel.AssociatedStatusId)))
      // &&
      //(!this._validation.isInvalidDropDown(this.LeadCheckListEditModel.ResponsibleRoleId)) &&
      //    (!this._validation.isInvalidDropDown(this.LeadCheckListEditModel.AssigneeId)))
      {

        //if (this.LeadCheckListEditModel.EndDate == null || this.LeadCheckListEditModel.EndDate == undefined) {
        //  let selectedPhase = this.associatedTask.find(x => x.Id == this.LeadCheckListEditModel.AssociatedStatusId);
        //  currentEndDate = this._validation.utcify(selectedPhase.EndDate);
        //  this.LeadCheckListEditModel.EndDate = this._validation.utcify(selectedPhase.EndDate);
        //}
        //else {
        currentEndDate = this.LeadCheckListEditModel.EndDate ? this._validation.utcify(this.LeadCheckListEditModel.EndDate) : null;
        this.LeadCheckListEditModel.EndDate = this.LeadCheckListEditModel.EndDate ? this._validation.utcify(this.LeadCheckListEditModel.EndDate) : null;
        /*  }*/

        //if (this.LeadCheckListEditModel.StartDate == null || this.LeadCheckListEditModel.StartDate == undefined) {
        //  let selectedPhase = this.associatedTask.find(x => x.Id == this.LeadCheckListEditModel.AssociatedStatusId);
        //  currentStartDate = this._validation.utcify(selectedPhase.StartDate);
        //  this.LeadCheckListEditModel.StartDate = this._validation.utcify(selectedPhase.StartDate);
        //}
        //else {
        currentStartDate = this.LeadCheckListEditModel.StartDate ? this._validation.utcify(this.LeadCheckListEditModel.StartDate) : null;
        this.LeadCheckListEditModel.StartDate = this.LeadCheckListEditModel.StartDate ? this._validation.utcify(this.LeadCheckListEditModel.StartDate) : null;
        /*}*/

        if (this.LeadCheckListEditModel.StartDate == null && this.LeadCheckListEditModel.EndDate != null) {
          this.Toast.addToast({ title: 'Error Occurred', msg: "Start date should not be empty", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        if (this.LeadCheckListEditModel.StartDate != null && this.LeadCheckListEditModel.EndDate == null) {
          this.Toast.addToast({ title: 'Error Occurred', msg: "End date should not be empty", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        if (this.LeadCheckListEditModel.StartDate > this.LeadCheckListEditModel.EndDate) {
          this.Toast.addToast({ title: 'Error Occurred', msg: "Start date should not greater than End date", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        if (this.LeadCheckListEditModel.Status === 2252 && !this._validation.IsDate(this.LeadCheckListEditModel.CompletedDate)) {
          this.isCompletedDateInvalid = true;
          this.CompletedDateInvalidMessage = "Completed Date is required";
          return;
        }
        else {
          this.isCompletedDateInvalid = false;
        }
        if (!this.isPhaseDateConfirmed) {
          let currentPhase = this.associatedTask.find(x => x.Id == this.LeadCheckListEditModel.AssociatedStatusId);
          if (currentPhase != null && currentPhase != undefined && currentPhase.EndDate != null && currentPhase.EndDate != undefined) {
            let currentphaseDate = currentPhase.EndDate;
            let currentPhaseStart = currentPhase.StartDate;
            if (this.previousTaskStartDate > currentStartDate || this.previousTaskEndDate > currentEndDate || this.previousTaskStartDate < currentStartDate || this.previousTaskEndDate < currentEndDate) {
              if ((currentEndDate != null && currentEndDate > currentphaseDate) || (currentStartDate != null && currentStartDate < currentPhaseStart)) {
                this.isPhaseDateConfirmed = true;
                this.modalRefPhaseDateConfirmation = this.modalService.show(template, { class: classes });
                return;
              }
            }
            //else if ((currentStartDate == null && currentEndDate != null && currentEndDate > currentphaseDate) || (currentStartDate != null && currentStartDate < currentPhaseStart && currentEndDate == null) || (currentStartDate == null && currentEndDate == null)) {
            //  this.isPhaseDateConfirmed = true;
            //  this.modalRefPhaseDateConfirmation = this.modalService.show(template, { class: classes });
            //  return;
            //}
          }
        }
        this.Loader.display(true);
        this.disableTaskEditSavebtn = true;

        this.LeadCheckListEditModel.CompletedDate = this._validation.utcify(this.LeadCheckListEditModel.CompletedDate);
        this.LeadCheckListEditModel.UserId = this.user.Id
        var d = new Date();
        this.LeadCheckListEditModel.TimeOffset = d.getTimezoneOffset();

        this._OfferService.UpdateLeadCheckList(this.LeadCheckListEditModel).subscribe(res => {
          if (res) {
            this.isbindAllTaskCalled = true;
            this.Shared.reloadOfferDetail(true);
            this.bindTaskPhaseDetails();
            var element = document.getElementById("divOfferTaskList");
            if (element != null && element != undefined) {
              this.scrollToTop(element, 200);
            }
            this.modalRef.hide();
            this.Loader.display(false);
            this.disableTaskEditSavebtn = false;
            this.isPhaseDateConfirmed = false;
            this.Toast.addToast({ title: 'Success', msg: 'Task Details Updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          }
          else {
            this.isPhaseDateConfirmed = false;
            this.Toast.addToast({ title: 'Error Occurred', msg: "Task Details Updatation Failed", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          }
        });
      }
      else {
        this.Loader.display(false);
        this.isPhaseDateConfirmed = false;
        this.disableTaskEditSavebtn = false;
      }
    }
    else {
      this.Loader.display(false);
      this.isPhaseDateConfirmed = false;
      this.disableTaskEditSavebtn = false;
    }
  }

  onAddTaskCancel() {
    this.isAddTaskFormSubmitted = false;
    this.disableTaskSavebtn = false;
    this.modalRef.hide();
  }
  isPhaseEditFormSubmitted = false;
  isPhaseCompletedDateInvalid = false;
  showDateChangePopup(template: TemplateRef<any>, classes) {
    this.modalRefConfirmation = this.modalService.show(template, { class: classes });
  }

  onPhaseEdit(val: boolean) {
    this.isPhaseEditFormSubmitted = true;
    if (this.EditPhaseForm.valid) {
      if (this.taskPhaseToEdit > 0) {
        if (this.PhaseInputModel.StartDate == null && this.PhaseInputModel.EndDate != null) {
          this.Toast.addToast({ title: 'Error Occurred', msg: "Start date should not be empty", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        if (this.PhaseInputModel.StartDate != null && this.PhaseInputModel.EndDate == null) {
          this.Toast.addToast({ title: 'Error Occurred', msg: "End date should not be empty", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        if (this.PhaseInputModel.StartDate > this.PhaseInputModel.EndDate) {
          this.Toast.addToast({ title: 'Error Occurred', msg: "Start date should not greater than End date", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        if (this.PhaseInputModel.IsPhaseCompleted && !this._validation.IsDate(this.PhaseInputModel.CompletedDate)) {
          this.isPhaseCompletedDateInvalid = true;
          return;
        }
        else {
          this.isPhaseCompletedDateInvalid = false;
        }

        this.PhaseInputModel.StartDate = this.PhaseInputModel.StartDate?this._validation.utcify(this.PhaseInputModel.StartDate):null;
        this.PhaseInputModel.EndDate = this.PhaseInputModel.EndDate?this._validation.utcify(this.PhaseInputModel.EndDate):null;
        this.PhaseInputModel.CompletedDate = this._validation.utcify(this.PhaseInputModel.CompletedDate);
        this.PhaseInputModel.IsEditAllDates = val;
        this.PhaseInputModel.loggedinuserid = this.user.Id;
        this.Loader.display(true);
        this._OfferService.UpdateTaskPhaseDetails(this.PhaseInputModel).subscribe(res => {
          if (res) {
            this.isbindAllTaskCalled = true;
            this.Shared.reloadOfferDetail(true);
            this.bindTaskPhaseDetails();
            var element = document.getElementById("divOfferTaskList");
            if (element != null && element != undefined) {
              this.scrollToTop(element, 200);
            }
            this.modalRef.hide();
            this.modalRefConfirmation.hide();
            this.Toast.addToast({ title: 'Success', msg: 'Associated Category updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          }
          else {
            this.Toast.addToast({ title: 'Error Occurred', msg: "Failed to update associated category", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          }
          this.Loader.display(false);
        });
      }
    }
  }

  onPhaseEditCancel() {
    this.isPhaseEditFormSubmitted = false;
    this.modalRef.hide();
  }

  disableTaskSavebtn = false;
  disableTaskEditSavebtn = false;
  onSaveTask() {
    this.isAddTaskFormSubmitted = true;
    if (!this.AddTaskForm.invalid) {
      if ((!this._validation.isInvalidDropDown(this.AddTaskModel.AssociatedStatusId)))
      //&&
      //(!this._validation.isInvalidDropDown(this.AddTaskModel.ResponsibleRoleId)) &&
      //(!this._validation.isInvalidDropDown(this.AddTaskModel.AssigneeId)))
      {

        //if (this.AddTaskModel.EndDate == null || this.AddTaskModel.EndDate == undefined) {
        //  let selectedPhase = this.associatedTask.find(x => x.Id == this.AddTaskModel.AssociatedStatusId);
        //  this.AddTaskModel.EndDate = this._validation.utcify(selectedPhase.EndDate);
        //}
        //else {
        if (this.AddTaskModel.EndDate == null || this.AddTaskModel.EndDate == undefined) {
          this.AddTaskModel.EndDate = null;
        }
        else {
          this.AddTaskModel.EndDate = this._validation.utcify(this.AddTaskModel.EndDate);
        }
        /*   }*/

        //if (this.AddTaskModel.StartDate == null || this.AddTaskModel.StartDate == undefined) {
        //  let selectedPhase = this.associatedTask.find(x => x.Id == this.AddTaskModel.AssociatedStatusId);
        //  this.AddTaskModel.StartDate = this._validation.utcify(selectedPhase.StartDate);
        //}
        //else {
        if (this.AddTaskModel.StartDate == null || this.AddTaskModel.StartDate == undefined) {
          this.AddTaskModel.StartDate = null;
        }
        else {
          this.AddTaskModel.StartDate = this._validation.utcify(this.AddTaskModel.StartDate);
        }
        /* }*/

        if (this.AddTaskModel.StartDate == null && this.AddTaskModel.EndDate != null) {
          this.Toast.addToast({ title: 'Error Occurred', msg: "Start date should not be empty", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        if (this.AddTaskModel.StartDate != null && this.AddTaskModel.EndDate == null) {
          this.Toast.addToast({ title: 'Error Occurred', msg: "End date should not be empty", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        if (this.AddTaskModel.StartDate > this.AddTaskModel.EndDate) {
          this.Toast.addToast({ title: 'Error Occurred', msg: "Start date should not greater than End date", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          return;
        }

        this.Loader.display(true);
        this.disableTaskSavebtn = true;

        this.AddTaskModel.LeadGuid = this.inputOfferGuid
        this.AddTaskModel.UserId = this.user.Id;

        this._OfferService.CreateOfferSpecificTask(this.AddTaskModel).subscribe(res => {
          if (res) {
            this.isbindAllTaskCalled = true;
            this.Shared.reloadOfferDetail(true);
            this.bindTaskPhaseDetails();
            var element = document.getElementById("divOfferTaskList");
            if (element != null && element != undefined) {
              this.scrollToTop(element, 200);
            }
            this.modalRef.hide();
            this.Toast.addToast({ title: 'Success', msg: 'Task added Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
            this.Loader.display(false);
            this.disableTaskSavebtn = false;
           
          }
          else {
            this.Toast.addToast({ title: 'Error Occurred', msg: "Failed to add task", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          }
        });
      }
      else {
        this.Loader.display(false);
        this.disableTaskSavebtn = false;
      }
    }
    else {
      this.Loader.display(false);
      this.disableTaskSavebtn = false;
    }
  }


  bindAssignee(role, selected) {
    //this._userManagerService.GetUserByRole(role).subscribe(res => {
    //    this.assigneeList = res;
    //    this.LeadCheckListEditModel.AssigneeId = selected;
    //});

    this.assigneeList = [];
    this.TaskAssignee.forEach(item => {
      if (item.RoleId != null && item.RoleId.includes("," + role.toString() + ",")) {
        this.assigneeList.push(item);
      }
    });
    this.LeadCheckListEditModel.AssigneeId = selected;
  }

  disableAdminCreatedTaskControls = true;
  currentTaskType = TaskType.AdminCreatedTask;

  taskPhaseToEdit = 0;
  LoadPhaseDataToEdit(template: TemplateRef<any>, classes, Id: number) {
    this.isPhaseEditFormSubmitted = false;
    this.isPhaseCompletedDateInvalid = false;
    this.taskPhaseToEdit = Id;
    let found = this.assignedPhaseDetails.find(x => x.Id === Id);
    if (found) {
      this.PhaseInputModel.Id = Id;
      this.PhaseInputModel.PhaseName = found.AssociatedStatusName;
      this.PhaseInputModel.StartDate = (found.StartDate);
      this.PhaseInputModel.EndDate = (found.EndDate);
      this.PhaseInputModel.IsPhaseCompleted = found.IsPhaseCompleted;
      this.PhaseInputModel.CompletedDate = found.CompletedDate ? (found.CompletedDate) : null;
    }

    this.modalRef = this.modalService.show(template, { class: classes });
  }

  UpdatePhaseDate() {
    this.isPhaseDateConfirmed = false;
  }

  previousTaskStartDate: Date;
  previousTaskEndDate: Date;

  LoadTaskDataToEdit(template: TemplateRef<any>, classes, LeadCheckListId) {
    this.Loader.display(true);
    this.disableTaskEditSavebtn = false;
    this.isCompletedDateInvalid = false;
    this.isPhaseDateConfirmed = false;
    this._OfferService.GetLeadChecklistTaskDetailsToEdit(LeadCheckListId).subscribe(response => {
      this.LeadCheckListEditModel = response;
      this.LeadCheckListEditModel.ResponsibleRoleId = this.LeadCheckListEditModel.ResponsibleRoleId === null ? 0 : this.LeadCheckListEditModel.ResponsibleRoleId;
      this.bindAssignee(this.LeadCheckListEditModel.ResponsibleRoleId, this.LeadCheckListEditModel.AssigneeId);
      this.previousTaskStartDate = this.LeadCheckListEditModel.StartDate ? this._validation.convertUTCDateToLocalDate(this.LeadCheckListEditModel.StartDate) : null;
      this.previousTaskEndDate = this.LeadCheckListEditModel.EndDate ? this._validation.convertUTCDateToLocalDate(this.LeadCheckListEditModel.EndDate) : null;
      this.LeadCheckListEditModel.StartDate = this.LeadCheckListEditModel.StartDate ? this._validation.convertUTCDateToLocalDate(this.LeadCheckListEditModel.StartDate) : null;
      this.LeadCheckListEditModel.EndDate = this.LeadCheckListEditModel.EndDate ? this._validation.convertUTCDateToLocalDate(this.LeadCheckListEditModel.EndDate) : null;
      this.LeadCheckListEditModel.CompletedDate = this.LeadCheckListEditModel.CompletedDate ? this._validation.convertUTCDateToLocalDate(this.LeadCheckListEditModel.CompletedDate) : null;
      if (this.LeadCheckListEditModel.CheckListId == null) {
        this.currentTaskType = TaskType.UserCreatedTask;
        this.disableAdminCreatedTaskControls = false;
      }
      else {
        this.currentTaskType = TaskType.AdminCreatedTask;
        this.disableAdminCreatedTaskControls = true;
      }

      this.modalRef = this.modalService.show(template, { class: classes });
      this.Loader.display(false);
    });
  }
  taskAdded = false;
  showAssignTask = false;
  onShowAssignTask() {
    this.showAssignTask = true;
  }

  scrollToTop(element, offset) {
    //this.scrollService.scrollTo(element, offset);
    $('html,body').animate({ scrollTop: ($(element).offset().top - offset) }, 500);
  }
  tasksSaved = false;
  showAddCalenderEventCheckbox = false;
  bindData() {
    this.associatedTask = [];

    this._OfferService.GetOfferTaskList(this.offerGuid, this.user.Id).subscribe(response => {
      this.taskList = response;
      this.taskList.forEach(item => {
        item.StartDate = item.StartDate ? this._validation.formatDatetoMMDDYYYY(this._validation.convertUTCDateToLocalDate(item.StartDate)) : null;
        item.EndDate = item.EndDate ? this._validation.formatDatetoMMDDYYYY(this._validation.convertUTCDateToLocalDate(item.EndDate)) : null;

        if (item.StartDate == null && item.EndDate == null) {
          item.IsCalenderEventAdded = null;
        }
      });
      this.eventCheckbox = this.taskList[0]?.AddCalenderEventChecked;
      if (this.taskList.length > 0) {
        this.taskAdded = true;
      }
      else {
        this.taskAdded = false;
        if (this.loggedInUserIsPropertyBroker) {
          this.showBadge.emit(true);
        }
        this.showAssignTask = false;
      }

      this.assignedPhaseDetails.forEach(item => {
        const data =
        {
          TableId: item["Id"],
          Id: item["AssociatedStatusId"],
          Name: item["AssociatedStatusName"],
          StartDate: item["StartDate"],
          EndDate: item["EndDate"],
          IsPhaseCompleted: item["IsPhaseCompleted"],
          IsCalenderEventAdded: item["IsCalenderEventAdded"],
          TotalNoteCount: item["TotalNoteCount"],
          ShowSubTask: (this.openedPhases != null && this.openedPhases.length > 0 && this.openedPhases.findIndex(i => i == item["AssociatedStatusId"]) > -1) ? true : false
        }
        this.associatedTask.push(data);
      });
      if (this.associatedTask.length > 0) {
        this.tasksSaved = true;
      }

      //this.taskList.forEach(item => {
      //    let found = this.associatedTask.find(x => x.Id === item["AssociatedStatusId"]);
      //    if (!found) {
      //        console.log(this.assignedPhaseDetails);
      //        let phaseDtls = this.assignedPhaseDetails.find(x => x.AssociatedStatusId === item["AssociatedStatusId"]);
      //        if (phaseDtls) {
      //            const data =
      //                {
      //                    Id: item["AssociatedStatusId"],
      //                    Name: item["AssociatedStatusName"],
      //                    StartDate: this._validation.convertUTCDateToLocalDate(phaseDtls.StartDate),
      //                    EndDate: this._validation.convertUTCDateToLocalDate(phaseDtls.EndDate),
      //                }
      //            this.associatedTask.push(data);
      //        }
      //        else {
      //            const data =
      //                {
      //                    Id: item["AssociatedStatusId"],
      //                    Name: item["AssociatedStatusName"],
      //                    StartDate: null,
      //                    EndDate: null,
      //                }
      //            this.associatedTask.push(data);
      //        }

      //    }
      //});
    });
  }

  GetTaskUnderStatus(statusId: number) {
    let found = this.taskList.find(x => x.AssociatedStatusId === statusId);
    return found
  }

  modalRef: BsModalRef;
  modalRefConfirmation: BsModalRef;
  modalRefPhaseDateConfirmation: BsModalRef;
  isSubmit = false;
  NotesInput = {} as INoteInput;

  taskList = [];

  openModal(template: TemplateRef<any>, classes) {
    this.isSubmit = false;
    this.isEditTaskFormSubmitted = false;
    this.isAddTaskFormSubmitted = false;
    this.AddTaskForm.reset();
    this.EditTaskForm.reset();
    this.resetAddTaskFeilds();
    this.NotesInput.Id = 0;
    this.NotesInput.Description = '';
    this.assigneeList = [];
    this.disableTaskSavebtn = false;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  resetAddTaskFeilds() {
    this.AddTaskModel.TaskName = null;
    this.AddTaskModel.StartDate = null;
    this.AddTaskModel.EndDate = null;
    this.AddTaskModel.AssociatedStatusId = 0;
    this.AddTaskModel.ResponsibleRoleId = 0;
    this.AddTaskModel.AssigneeId = 0;
  }

  onChangeStatus(LeadCheckListId, Status) {
    this._OfferService.ChangeLeadChecklistTaskStatus(LeadCheckListId, Status, this.user.Id).subscribe(response => {
      if (response) {
        this.Toast.addToast({ title: 'Success', msg: 'Task Status Updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: "Task Status Updatation Failed", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    });
  }


  LeadCheckListIdTodelete: number;
  openDeleteModal(template: TemplateRef<any>, classes: any, LeadCheckListIdTodelete: number) {
    this.LeadCheckListIdTodelete = LeadCheckListIdTodelete;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  onTaskDelete() {
    this.Loader.display(true);
    this._OfferService.DeleteLeadChecklistTask(this.LeadCheckListIdTodelete, this.user.Id).subscribe(response => {
      if (response) {
        this.isbindAllTaskCalled = true;
        this.Toast.addToast({ title: 'Success', msg: 'Task Deleted Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        this.Shared.reloadOfferDetail(true);
        this.bindTaskPhaseDetails();
        var element = document.getElementById("divOfferTaskList");
        if (element != null && element != undefined) {
          this.scrollToTop(element, 200);
        }
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: "Task Deletion Failed", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }

      this.Loader.display(false);
    });
  }
  PhaseIdToDelete = 0;
  openPhaseDeleteModal(template: TemplateRef<any>, classes: any, PhaseToDelete: number) {
    this.PhaseIdToDelete = PhaseToDelete;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  onPhaseDelete() {
    this.Loader.display(true);
    this._OfferService.DeleteTaskPhaseDetails(this.PhaseIdToDelete, this.user.Id).subscribe(response => {
      if (response) {
        this.isbindAllTaskCalled = true;
        this.Toast.addToast({ title: 'Success', msg: 'Phase Deleted Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        this.bindTaskPhaseDetails();
        this.Shared.reloadOfferDetail(true);
        var element = document.getElementById("divOfferTaskList");
        if (element != null && element != undefined) {
          this.scrollToTop(element, 200);
        }
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: "Phase Deletion Failed", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.Loader.display(false);
    });
  }


  selectedAssignees: string[];

  openModalForNotes(template: TemplateRef<any>, classes, itemLead, associatedStatusName) {
    this.isSubmit = false;
    this.NotesInput.Id = 0;
    this.NotesInput.Description = '';
    this.NotesInput.UserId = this.user.Id;
    this.NotesInput.ObjectId = this.offerDetails.LeadDetailId;
    this.NotesInput.LeadChecklistId = itemLead.LeadCheckListId;
    this.NotesInput.ObjectTypeId = 303;
    this.NotesInput.AssociatedStatusName = associatedStatusName;
    this.NotesInput.TaskName = itemLead.TaskName;
    itemLead.UnReadNoteCount = 0;
    this.modalRef = this.modalService.show(template, {
      class: classes, ignoreBackdropClick: true, keyboard: false,
      backdrop: true });
  }
  closeModal(status: boolean) {
    if (status) {
      this.isbindAllTaskCalled = true;
      this.bindTaskPhaseDetails();
      this.Shared.reloadOfferDetail(true);
      var element = document.getElementById("divOfferTaskList");
      if (element != null && element != undefined) {
        this.scrollToTop(element, 200);
      }
    }
  }
  AddCalenderEvent(id, phaseId, subscribe) {
    this.Loader.display(true);
    var d = new Date();
    var offset = d.getTimezoneOffset();
    this._OfferService.AddCalenderEvent(id, phaseId, this.user.Id, subscribe ? 1 : 0, offset).subscribe(item => {
      this.Loader.display(false);
      this.eventCheckbox = this.eventCheckbox ? subscribe : this.taskList.filter(i => i.IsCalenderEventAdded == false).length == 0;
      var msg = subscribe ? "added" : "canceled";
      this.Toast.addToast({ title: 'Success', msg: 'Calendar event ' + msg + ' successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })

    });
  }

  addAllEvents() {
    this.Loader.display(true);
    var d = new Date();
    var offset = d.getTimezoneOffset();
    this._OfferService.CalenderEventSubscription(this.offerDetails.LeadDetailId, this.user.Id, this.eventCheckbox ? 1 : 0, offset).subscribe(item => {
      this.taskList.forEach(item => {
        if (item.StartDate != null && item.EndDate != null) {
          item.IsCalenderEventAdded = this.eventCheckbox;
        }
      });

      this.associatedTask.forEach(item => {

        item.IsCalenderEventAdded = this.eventCheckbox;
      });

      this.Loader.display(false);

      var msg = this.eventCheckbox ? "added" : "canceled";
      this.Toast.addToast({ title: 'Success', msg: 'Calander events ' + msg + ' successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })

    });
  }

  showTaskList(phaseId: string, i: number) {
    if (this.associatedTask != null && this.associatedTask.length > 0) {
      let currentPhase = this.associatedTask.find(i => i.Id == phaseId);
      if (currentPhase != null && currentPhase != undefined && !currentPhase.ShowSubTask) {
        currentPhase.ShowSubTask = true;
      }
      else {
        currentPhase.ShowSubTask = false;
      }
      this.openedPhases = this.associatedTask.filter(m => m.ShowSubTask).map(m => m.Id);
    }
  }

}
